// Vendor
import { CommonModule } from '@angular/common';
// Modules
import { DateRangeModule } from 'NewAngular/features/components/date-controls/date-range/date-range.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class HistoricalDataTableModule {
}
HistoricalDataTableModule.ɵfac = function HistoricalDataTableModule_Factory(t) { return new (t || HistoricalDataTableModule)(); };
HistoricalDataTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HistoricalDataTableModule });
HistoricalDataTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DateRangeModule, FeatureNeededModule, IconModule] });
